import Logo from './Logo'

Logo.install = (Vue, options) => {
  Vue.component(Logo.name, Logo)
}
export default Logo


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Logo/index.js
// module id = null
// module chunks = 